module.exports = __webpack_public_path__ + "img/exchange-2-m.26c50e22.png";